import './instrument'
import React, { useEffect, useState } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import * as Sentry from '@sentry/react'
import App from './App'

const basename = import.meta.env.BASE_URL || ''

function Root() {
  const [isReady, setIsReady] = useState(false)

  useEffect(() => {
    setIsReady(true)
  }, [])

  if (!isReady) {
    return null
  }

  return (
    <BrowserRouter basename={basename}>
      <App />
    </BrowserRouter>
  )
}

const container = document.getElementById('root')
if (container) {
  createRoot(container, {
    // Callback called when an error is thrown and not caught by an ErrorBoundary.
    onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
      console.warn('Uncaught error', error, errorInfo.componentStack)

      const full = `${error?.message ?? ''} ${error?.stack ?? ''}`.toLowerCase()
      const isChatError =
        full.includes('be-frame') ||
        full.includes('niceincontact') ||
        full.includes('chat.js') ||
        full.includes('hidewindow') ||
        (full.includes('window[') && full.includes('is not a function'))

      if (isChatError) return
    }),
    // Callback called when React catches an error in an ErrorBoundary.
    onCaughtError: Sentry.reactErrorHandler(),
    // Callback called when React automatically recovers from errors.
    onRecoverableError: Sentry.reactErrorHandler()
  }).render(
    <React.StrictMode>
      <Root />
    </React.StrictMode>
  )
}
